import { FormInputTypes } from '@components/_old/dynamicForm';
import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';
import { IListingFilterWidgetSection } from '@components/widgets/listing-filter-widget';
import { IAbstractRecord } from '@models';

export const headers: Record<string, EnhancedTableHeader> = {
  name: {
    name: 'name',
    title: 'Name',
    type: EnhancedTableHeaderType.Clickable,
    callback: () => undefined,
  },
  applicationContactDetails: {
    name: 'applicationContactDetails',
    title: 'Customer',
    type: EnhancedTableHeaderType.Text,
  },
  plan: {
    name: 'plan',
    title: 'Plans',
    type: EnhancedTableHeaderType.Text,
    tooltipSettings: {
      headers: {
        Plan: {
          name: 'Plan',
          title: 'Plan',
          type: EnhancedTableHeaderType.Text,
        },
        Class: {
          name: 'Class',
          title: 'Class',
          type: EnhancedTableHeaderType.Currency,
        },
        AmbulatoryCoverage: {
          name: 'AmbulatoryCoverage',
          title: 'Ambulatory Coverage',
          type: EnhancedTableHeaderType.Currency,
        },
        TotalPremium: {
          name: 'TotalPremium',
          title: 'Total Premium',
          type: EnhancedTableHeaderType.Currency,
        },
        Status: {
          name: 'Status',
          title: 'Status',
          type: EnhancedTableHeaderType.Text,
        },
        StatusReason: {
          name: 'StatusReason',
          title: 'Status Reason',
          type: EnhancedTableHeaderType.Text,
        },
      },
    },
  },
  agency: {
    name: 'agency',
    title: 'Business Partner',
    type: EnhancedTableHeaderType.Text,
  },
  agent: {
    name: 'agent',
    title: 'Business User',
    type: EnhancedTableHeaderType.Text,
  },
  effectiveDate: {
    name: 'effectiveDate',
    title: 'Effective Date',
    type: EnhancedTableHeaderType.Date,
  },
  expiryDate: {
    name: 'expiryDate',
    title: 'Expiry Date',
    type: EnhancedTableHeaderType.Date,
  },
  createdOn: {
    name: 'createdOn',
    title: 'Created on',
    type: EnhancedTableHeaderType.Date,
  },
  modifiedOn: {
    name: 'modifiedOn',
    title: 'Modified on',
    type: EnhancedTableHeaderType.Date,
  },
};

export function filterSectionsContent(
  lovs: Record<string, Record<string, string>>,
  filterValues: IAbstractRecord,
  userRoles: string[]
): IListingFilterWidgetSection[] {
  const newFilterSections: IListingFilterWidgetSection[] = [
    {
      title: 'Filters',
      inputs: {
        ...((userRoles.includes('Insurance-Admin') ||
          userRoles.includes('Insurance-Underwriter')) && {
          assignedAgencyID: {
            name: 'assignedAgencyID',
            title: 'Business Partner',
            type: FormInputTypes.chips,
            value: filterValues?.assignedAgencyID || [],
            placeholder: 'Business Partner',
            triggerUpdate: true,
            selectOptions: { ...lovs.assignedAgencyID },
          },
        }),
        product: {
          name: 'product',
          title: 'Plan',
          type: FormInputTypes.chips,
          value: filterValues?.product || [],
          placeholder: 'Plan',
          triggerUpdate: true,
          selectOptions: { ...lovs.product },
        },
        effectiveDate: {
          name: 'effectiveDate',
          title: 'Effective Date',
          type: FormInputTypes.newdaterange,
          value: filterValues.effectiveDate || [],
          placeholder: 'Effective Date',
          triggerUpdate: true,
        },
        createdDate: {
          name: 'createdDate',
          title: 'Created On',
          type: FormInputTypes.newdaterange,
          value: filterValues.createdDate || [],
          placeholder: 'Created On',
          triggerUpdate: true,
        },
      },
    },
  ];
  return newFilterSections;
}
